import {FC, useEffect, useState} from "react";
import {FieldValues, SubmitHandler, useForm, useWatch} from "react-hook-form";
import {
    AdditionalServiceDto,
    FeeTypeDto,
    AccommodationTypeDto,
} from "../types/contracts";
import {IParticipant} from "../types";
import {useFetchCurrentEvent} from "../hooks";
import {FormInputs} from "./shared";
import {FormField} from "../types/enums";

type FormGroupProps = {
    onFormChange: (newParticipant: IParticipant) => void;
    accommodations: AccommodationTypeDto[];
    setAccommodations: React.Dispatch<
        React.SetStateAction<AccommodationTypeDto[]>
    >;
};

const FormGroup: FC<FormGroupProps> = ({onFormChange, accommodations, setAccommodations}) => {
    const {event, isLoading, isPending} = useFetchCurrentEvent();

    const [feeTypes, setFeeTypes] = useState<FeeTypeDto[]>([]);
    const [dates, setDates] = useState<string[]>([]);
    const [additionalServices, setAdditionalServices] = useState<
        AdditionalServiceDto[]
    >([]);
    useEffect(() => {
        if (!event) return;

        setFeeTypes(event.feeTypes);
        setDates(event.dates);
        setAdditionalServices(event.additionalServices);
        setAccommodations(event.accommodations);
    }, [event]);

    const {
        register,
        handleSubmit,
        control,
        reset,
        formState: {errors, isValid},
        unregister,
        watch,
    } = useForm({mode: "onChange"});
    const stayDatesMultiple = useWatch({control, name: "stayDatesMultiple"});
    const accommodationType = useWatch({control, name: "accommodationType"});
    const defaultVisibleFieldsGroup = [FormField.FeeType];
    const [visibleFieldsGroup, setVisibleFieldsGroup] = useState<FormField[]>(
        defaultVisibleFieldsGroup
    );

    const onSubmit: SubmitHandler<FieldValues> = (data: any) => {
        data.isValid = isValid;

        const stayDatesNormalized = Array.isArray(data["stayDatesMultiple"])
            ? data["stayDatesMultiple"]
            : [data["stayDatesMultiple"]].filter(Boolean);
        const newdata: IParticipant = {
            ...data,
            stayDates: stayDatesNormalized,
            additionalServicesIds: Array.isArray(data.additionalServices)
                ? data.additionalServices
                : [],
            eventId: event?.id || "",
            eventName: event?.name || "",
            feeTypeName: feeTypes.find((ft) => ft.id === data.feeTypeId)?.name || "",
            additionalServices: Array.isArray(data.additionalServices)
                ? additionalServices.filter((as) =>
                    data.additionalServices.includes(as.id)
                )
                : [],
            dateOfBirth: `${data.birthDate}`,
            identityCardNumber: `${data.idNumber}`,
            membershipCardNumber: `${data.membershipNumber ?? ""}`,
        };
        console.info("newdata", newdata);
        onFormChange(newdata);
        reset();
    };

    return (
        <form
            className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg"
            onSubmit={handleSubmit(onSubmit)}
        >
            {isPending && <div>Načítám data události...</div>}
            <FormInputs
                register={register}
                unregister={unregister}
                dates={dates}
                additionalServices={additionalServices}
                stayDatesMultiple={stayDatesMultiple}
                errors={errors}
                feeTypes={feeTypes}
                visibleFields={visibleFieldsGroup}
                defaultVisibleFields={defaultVisibleFieldsGroup}
                setVisibleFields={setVisibleFieldsGroup}
                accommodationType={accommodationType}
                accommodations={accommodations}
                watch={watch}
            />

            <button
                type="submit"
                disabled={!isValid || isLoading}
                className={`w-full py-2 mt-2 rounded text-white ${
                    !isValid || isLoading
                        ? "bg-blue-300 cursor-not-allowed"
                        : "bg-blue-500 hover:bg-blue-600"
                }`}
            >
                Přidat účastníka
            </button>
        </form>
    );
};
export default FormGroup;
